import gButton from "@/components/g-button/g-button.vue";
import gForm from "@/components/g-form/g-form.vue";
import ActionForm from "@/mixins/ActionForm";
import { CepService } from "@/shared/services/CEP";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { defineComponent } from "vue";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import CidadeController from "@/shared/controllers/cidade/cidadeController";

const name = "LoteFrete";
export default defineComponent({
  name,
  mixins: [ActionForm],
  components: {
    "g-button": gButton,
    "g-form": gForm,
  },
  props: {},
  setup(){
    return {
      v$: useVuelidate()
    }
  },
  mounted() {
    this.populateLote();
    // this.populateFrete();
    this.getAllLoteFrete();
    this.getCepByFreteSelecionado();
    this.ImagemEmpresa();
    this.popularDropDownEstado();
  },

  updated() {},
  data() {
    return {
      // DesativaLote: false,
      //DesativaSequencia: false,
      popupCancelaOrc: false,
      imagemEmpresa: '',
      CidadeArray:[],
      EstadoArray: [],
      CidadeId: null,
      cepValue: null,
      cidadeValue: null,
      copiaOrcamentoQuantidade: false,
      freteSelecionado: null,
      loteArray: [],
      loteFrete: 0,
      loteSelecionado: 2,
      podeAvancar: true,
      EstadoId: null,
      prototipo: false,
      reorcamento: false, 
      riscoFaca: false,
      sequenciaSelecionada: false,
      submit: false,
      teste: null,
      timerCidade: null,
      tipoFreteSelecionado: null,
      ufValue: null,
      sequenciaArray: [
        { value: true, campo: "Sim" },
        { value: false, campo: "Não" },
      ],
      freteArray: [
        { value: 0, text: "CIF" },
        { value: 1, text: "FOB - Cliente Retira" },
        { value: 2, text: "CIF - Cadastro" },
        { value: 3, text: "CIF - Redespacho" },
      ],
      TipoFreteArray: [
        { value: 0, text: "Fracionado" },
        { value: 1, text: "Fechado" },
      ],
    };
  },

  validations() {
    let loteSelecionado = {}
    let sequenciaSelecionada = {}
    let freteSelecionado = {}
    let cidadeId = {}
    let tipoFreteSelecionado = {}
    let estadoId = {}

    if(this.loteSelecionado !== null) {
      loteSelecionado = {
        required: helpers.withMessage('O campo Lote é obrigatório', required),
        $autoDirty: true
      }
    }
    if(this.sequenciaSelecionada !== null) {
      sequenciaSelecionada={
        required: helpers.withMessage('O campo Lote é obrigatório', required),
        $autoDirty: true
      }
    }

    if(this.cidadeId !== null && this.tipoFreteSelecionado === null && this.freteSelecionado !== 1) {
      tipoFreteSelecionado={
        required: helpers.withMessage('O campo Tipo Frete é obrigatório se houver uma cidade', required),
        $autoDirty: true
      }
    }

      freteSelecionado={
        required: helpers.withMessage('O campo Frete é obrigatório', required),
      }



    if(this.freteSelecionado != 1)
    {
      estadoId = {
        required: helpers.withMessage('O campo UF é obrigatório', required),
        $autoDirty: true
      }
      cidadeId = {
        required: helpers.withMessage('O campo Cidade é obrigatório', required),
        $autoDirty: true
      }
    }

      loteSelecionado = {
        required: helpers.withMessage('O campo Lote é obrigatório', required),
        $autoDirty: true
      }

      return {
        loteSelecionado:loteSelecionado,
        freteSelecionado:freteSelecionado,
        sequenciaSelecionada:sequenciaSelecionada,
        tipoFreteSelecionado: tipoFreteSelecionado,
        CidadeId:cidadeId,
        EstadoId: estadoId
        // cepValue:{
        //     required: helpers.withMessage('O campo CEP é obrigatório', required),
        //     $autoDirty: true
        //   },
      }
  },

  methods: {
    cancelaOrcamento() {
      this.$isLoading(true)
      OrcamentoController.DeleteOrcamento(this.$route.params.id).requisicao
      .then(() =>
        this.popupCancelaOrc = false,
        this.$toast.add({severity:'success', detail:'Orçamento Excluido com Sucesso!', life: 5000}),
        setTimeout(() => {
          this.$isLoading(false),
          this.$router.push('/produto-novo-inicio');
        },2000))
    },
    fechaPopupCancelar() {
      this.popupCancelaOrc = false;
    },
    abrePopupCancelarOrcamento(){
      this.popupCancelaOrc = true;
    },
    ImagemEmpresa(){
      OrcamentoController.GetNomeEmpresaByOrcamentoId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `http://${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
    getAllLoteFrete(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + (`Orcamento/GetLoteFretebyOrcamentoId/${this.$route.params.id}`),
      })
      .then((response) => {
        if(response.data.data != null)
        {
          this.loteSelecionado=response.data.data.informacaoLote
          this.sequenciaSelecionada = response.data.data.sequencia
          this.freteSelecionado= response.data.data.indicadorDeTipoFrete

          if(this.freteSelecionado != 1)
          {
            this.EstadoId = response.data.data.estadoId
            this.buscarcidade()
            this.CidadeId = response.data.data.cidadeId

          }

          this.reorcamento = response.data.data.reorcamento;
          this.copiaOrcamentoQuantidade = response.data.data.copiaOrcamentoQuantidade;
          this.tipoFreteSelecionado = response.data.data.tipoFreteEnum

          if( response.data.data.riscoFaca == true)
          {
            this.riscoFaca = true
          }
          if(response.data.data.prototipo == true)
          {
            this.prototipo = true
          }
        }
      })
      .catch(() => {
      })
    },

    carregarInformacaoCidadeUfCliente(){
      if(this.freteSelecionado===2){
        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + (`Orcamento/GetCidadeEst/${this.$route.params.id}`),
        })
        .then((response) => {
          this.OrcamentoId = response.data.data;
          this.cidadeValue = response.data.data.nomeCidade;
          this.ufValue = response.data.data.siglaEstado;
          this.EstadoId = response.data.data.estadoId;
          this.buscarcidade()
          this.CidadeId = response.data.data.cidadeId;
        })
        .catch(() => {
        })
      }
      else {
        this.cidadeValue = null;
        this.ufValue = null;
      }
    },

    insertLoteFrete() {
      this.$refs.botaoContinuar.isBusy()
      if (this.tipoFreteSelecionado == 3)
      {
        this.tipoFreteSelecionado = null
      }
      this.freteSelecionado === 1 ? this.tipoFreteSelecionado = null : this.tipoFreteSelecionado
  
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'LoteFrete/PostInsertDadosLoteFrete',
        data: {
          CEP: this.cepValue,
          OrcamentoId:this.$route.params.id,
          IndicadorDeTipoFrete:this.freteSelecionado,
          InformacaoLote:this.loteSelecionado,
          Prototipo:this.prototipo,
          RiscoFaca:this.riscoFaca,
          Sequencia:this.sequenciaSelecionada,
          CidadeId:this.CidadeId,
          SiglaEstado:this.ufValue,
          TipoFreteEnum: this.tipoFreteSelecionado
        }
      })
      .then((response) => {
        response
        if(response.data.data == null && response.data.codigoGenerico == 'CidadeNaoEncontrada'){
          this.$toast.add({
            severity:'error', 
            summary: 'ERRO', 
            detail:"Não foi possível encontrar a cidade e/ou o CEP, o orçamento não pode ser concluído.", 
            life: 5000
          })
        } else {
          this.$router.push(`/produto-novo/${this.$route.params.id}/info-basicas`);
        }
      })
      .finally(this.$refs.botaoContinuar.isBusy)
      
    },

    voltarstep1() {
      this.$router.push(`/produto-novo/${this.$route.params.id}/infos-cliente`);
    },

    desativaLoteSwitch() {
      this.DesativaLote=true
      // this.DesativaSequencia=false
      this.loteSelecionado=null
    },

    desativaSequenciaSwitch() {
      this.DesativaLote=false
      // this.DesativaSequencia=true
      // this.sequenciaSelecionada=null
    },

    ativaLoteSequencia(){
      this.DesativaLote=false
      // this.DesativaSequencia=false
      this.loteSelecionado=null
      // this.sequenciaSelecionada=null
    },

    populateLote() {
      this.$isLoading(true)
      this.axios({
        method: "get",
        url: process.env.VUE_APP_WEB_API + "LoteFrete/GetEnumInformacaoLote",
      })
      .then((response) => {
        this.loteArray = response.data;
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },
    setCidade () {
      let cidade = this.CidadeArray.find((Element) => Element.id == this.CidadeId)
      let estado = this.EstadoArray.find((Element) => Element.id == cidade.estadoId)
  
      if(estado)
        this.objFiltro.EstadoId = estado.id
  
    },
    buscarcidade(){
      this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + 'Cidade/getbyestado',
          data: {
              id: this.EstadoId
          }
        })
          .then((response) => {
            this.CidadeArray = response.data.data


          })
          .catch(() => {
          });
        },
        buscarCidadeSemEstado(event){

          window.clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.CidadeArray = CidadeController.getByCidadeEstado(event).CidadeArray;
          }, 1000);
        },

    // populateFrete() {
    //   this.axios({
    //     method: 'get',
    //     url: process.env.VUE_APP_WEB_API + "LoteFrete/GetEnumIndicadorTipoFrete",
    //   })
    //     .then((response) => {
    //       this.freteArray = response.data;
    //     })
    //     .catch(() => {
    //     });
    // },

    async getCEP() {
      var dados = await CepService.getCep(this.cepValue)
      this.cidadeValue = dados.nomeCidade;
      this.ufValue = dados.ufSigla;
      this.podeAvancar = !(!this.cidadeValue && !this.ufValue);
    },

    verificaLote() {
      if(this.freteSelecionado === 2){
        this.getCidadeEst()
      } 
      if(this.freteSelecionado === 0 || this.freteSelecionado === 3){
        this.getCepByFreteSelecionado()
      }
      else {
        this.cidadeValue = null
        this.ufValue = null
        this.cepValue = null
        this.CidadeId = null
        this.EstadoId = null
      }
    },

    getCidadeEst() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + (`Orcamento/GetCidadeEst/${this.$route.params.id}`),
      })
      .then((response) => {
        this.OrcamentoId = response.data.data;
        this.cepValue = response.data.data.cep;
        this.cidadeValue = response.data.data.nomeCidade;
        this.ufValue = response.data.data.siglaEstado;
        
        this.EstadoId = response.data.data.estadoId;
        this.buscarcidade()
        this.CidadeId = response.data.data.cidadeId;
        this.$isLoading(false)
      })
      .catch(() => {
        this.$isLoading(false)
      })
    },
    getCepByFreteSelecionado() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + (`Orcamento/getCepByFreteSelecionado/${this.$route.params.id}`),
      })
      .then((response) => {
        if(this.freteSelecionado != 1)
        {
        this.cepValue = response.data.data.cep;
        this.cidadeValue = response.data.data.nomeCidade;
        this.ufValue = response.data.data.siglaEstado;
        }
        this.$isLoading(false)
      })
      .catch(() => {
        this.$isLoading(false)
      })
    },

    step3() {
      this.submit = true
      if(this.v$.$invalid === true){
        this.v$.$silentErrors.forEach(error=>{
          this.$toast.add({severity:'error', summary: 'ERRO', detail:error.$message, life: 5000})
        })
      } else if(this.podeAvancar) {
        this.insertLoteFrete()
      } else {
        this.$toast.add(
        {
          severity:'error', 
          summary: 'ERRO', 
          detail:"Não foi possível encontrar a cidade e/ou o CEP, o orçamento não pode ser concluído.", 
          life: 5000
        })
      }
    },

    atualizaLote() {
      if(this.sequenciaSelecionada) {
        this.loteSelecionado = 2;
      }
    },

    atualizaSequencia() {
      if((this.loteSelecionado === 0 || this.loteSelecionado === 1)) {
        this.sequenciaSelecionada = false;
      }
    },

    getTipoFreteByCidadeId() {
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'LoteFrete/GetTipoFreteByCidadeId',
        data: {
          OrcamentoId:this.$route.params.id,
          CidadeId:this.CidadeId,
          SiglaEstado:this.ufValue
        }
      })
      .then((response) => {
        this.TipoFreteArray = []
        if(response.data.data.fracionado){
          this.TipoFreteArray.push({"text": "Fracionado", "value": 0})
        }
        if(response.data.data.fechado){
          this.TipoFreteArray.push({"text": "Fechado", "value": 1})
        }
        if(!response.data.data.fechado && !response.data.data.fracionado){
          this.TipoFreteArray.push({"text": "Sem Tipo Frete", "value": 3})
        }
      })
      .catch(() => {
      });
    },
    popularDropDownEstado(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Estado/get',
      })
        .then((response) => {
          this.EstadoArray = response.data.data
  
        })
        .catch(() => {
        });
    },
  },

  watch: {
    CidadeId() {
      window.clearTimeout(this.timerCidade)
      this.timerCidade = setTimeout(() => {
        this.getTipoFreteByCidadeId()
      }, 1000);
    }
  }
});